<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <v-snackbar v-model="showsnackbar" color="#63028F" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{msg}}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color:white;">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <v-layout wrap>
      <v-flex xs12>
        <v-layout wrap justify-start>
          <v-flex xs12 sm12 md10 text-left>
            <span
              style="font-family:opensansregular;font-size:12px;color:#686868;"
              class="text-capitalize"
            >Category</span>
            <v-icon size="15" color="#686868">mdi-chevron-right</v-icon>
            <span
              style="font-family:opensansregular;font-size:12px;color:#686868;"
              class="text-capitalize"
            >{{$route.params.name}}</span>
            <v-icon size="15" color="#686868">mdi-chevron-right</v-icon>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-center>
          <v-flex py-2 xs12 sm12 md12 lg12 xl12>
            <v-img src="./../../assets/images/a9.png" contain>
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="#63028F"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex xs12>
            <v-layout px-2 pt-4 wrap>
              <v-flex px-2 text-left class="align-content-center">
                <span style="font-family:opensansbold;font-size:14px;color:#464646">Sort by</span>
              </v-flex>
              <v-flex px-2 text-center>
                <v-btn
                  small
                  :ripple="false"
                  text
                  block
                  class="text-capitalize"
                  @click="sortProducts('-popularity')"
                >
                  <span style="font-family:opensansregular;font-size:12px;">Popularity</span>
                </v-btn>
                <v-progress-linear
                  v-if="sortType=='-popularity'"
                  :value="100"
                  :background-opacity="0"
                  color="#63028F"
                  height="2"
                ></v-progress-linear>
              </v-flex>
              <v-flex px-2 text-left>
                <v-btn
                  small
                  :ripple="false"
                  text
                  block
                  class="text-capitalize"
                  @click="sortProducts('price')"
                >
                  <span
                    style="font-family:opensansregular;font-size:12px;text-transform:none;"
                  >Price - Low to High</span>
                </v-btn>
                <v-progress-linear
                  v-if="sortType=='price'"
                  :value="100"
                  :background-opacity="0"
                  color="#63028F"
                  height="2"
                ></v-progress-linear>
              </v-flex>
              <v-flex px-2 text-left>
                <v-btn
                  small
                  :ripple="false"
                  text
                  block
                  class="text-capitalize"
                  @click="sortProducts('-price')"
                >
                  <span
                    style="font-family:opensansregular;font-size:12px;text-transform:none;"
                  >Price - High to Low</span>
                </v-btn>
                <v-progress-linear
                  v-if="sortType=='-price'"
                  :value="100"
                  :background-opacity="0"
                  color="#63028F"
                  height="2"
                ></v-progress-linear>
              </v-flex>
              <v-flex px-2 text-left>
                <v-btn
                  small
                  :ripple="false"
                  text
                  block
                  class="text-capitalize"
                  @click="sortProducts('-account_create_at')"
                >
                  <span style="font-family:opensansregular;font-size:12px;">Newest</span>
                </v-btn>
                <v-progress-linear
                  v-if="sortType=='-account_create_at'"
                  :value="100"
                  :background-opacity="0"
                  color="#63028F"
                  height="2"
                ></v-progress-linear>
              </v-flex>
              <v-flex px-2 text-left>
                <v-btn
                  small
                  :ripple="false"
                  text
                  block
                  class="text-capitalize"
                  @click="sortProducts('-discount')"
                >
                  <span style="font-family:opensansregular;font-size:12px;">Discount</span>
                </v-btn>
                <v-progress-linear
                  v-if="sortType=='-discount'"
                  :value="100"
                  :background-opacity="0"
                  color="#63028F"
                  height="2"
                ></v-progress-linear>
              </v-flex>
              <v-flex px-2 md2 text-right>
                <span
                  style="font-family:opensanssemibold;font-size:12px;color:#464646"
                >Showing {{pagination.startingcount}} - {{pagination.endingcount}} of {{pagination.count}} items</span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout py-2 wrap>
          <v-flex xs12>
            <v-divider></v-divider>
          </v-flex>
        </v-layout>
        <v-layout v-if="products.length>0" px-2 wrap justify-start>
          <v-flex py-2 xs6 sm4 md3 lg2 v-for="(item,i) in products" :key="i">
            <v-card tile flat>
              <v-layout wrap justify-center>
                <v-flex xs4 md2 text-center>
                  <v-card v-if="item.discountpercentage" color="#F13F3F" flat>
                    <span style="font-family:opensanssemibold;font-size:12px;color:white">{{item.discountpercentage}} %</span>
                  </v-card>
                  <span v-else style="font-size:1px;">.</span>
                </v-flex>
                <v-flex></v-flex>
                <v-flex xs12 text-center>
                  <v-img :src="baseURL+'/u/'+item.photos[0]" height="100px" contain>
                    <template v-slot:placeholder>
                      <v-row class="fill-height ma-0" align="center" justify="center">
                        <v-progress-circular indeterminate color="#63028F"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-flex>
                <v-flex
                  @click="$router.push('/'+item._id+'/'+item.productname)"
                  xs10
                  text-center
                  style="cursor:pointer;height:50px"
                >
                  <span
                    style="font-family:opensanssemibold;font-size:12px;color:#2D2D2D"
                    v-if="item.productname.length>30"
                  >{{item.productname.slice(0,25)+'...'}}</span>
                  <span
                    style="font-family:opensanssemibold;font-size:12px;color:#2D2D2D"
                    v-else
                  >{{item.productname}}</span>
                </v-flex>
                <v-flex xs6 text-right>
                  <span
                    style="font-family:opensanssemibold;font-size:14px;color:#2D2D2D"
                  >₹ {{item.price}}</span>
                </v-flex>
                <v-flex xs6 pl-2 text-left>
                  <span
                    v-if="item.price!=item.mrp"
                    style="font-family:opensanssemibold;font-size:12px;color:#C6C6C6"
                  >
                    <s>₹ {{item.mrp}}</s>
                  </span>
                  <span v-else style="font-size:1px;">.</span>
                </v-flex>
                <v-flex xs12 text-center>
                  <v-btn
                    v-if="item.instock"
                    small
                    outlined
                    depressed
                    :ripple="true"
                    color="#dadada"
                    @click="addToCart(item._id)"
                  >
                    <v-icon style="font-size:14px;color:#393939">mdi-cart</v-icon>
                    <span
                      style="font-family:opensanssemibold;font-size:12px;color:#393939;"
                      class="text-capitalize px-1"
                    >&nbsp;Add to Cart</span>
                  </v-btn>
                  <v-btn
                    v-if="!item.instock"
                    small
                    outlined
                    depressed
                    :ripple="false"
                    color="#d90429"
                  >
                    <span
                      style="font-family:opensanssemibold;font-size:12px;color:#d90429;text-transform:none;"
                    >&nbsp;Out of Stock</span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout wrap v-else>
          <v-flex xs12>
            <span style="font-family:opensanssemibold;font-size:16px;color:#393939;">No items found</span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import store from "./../../store";
export default {
  props: ["productData", "pagination", "sorting"],
  data() {
    return {
      appLoading: false,
      timeout: 5000,
      showsnackbar: false,
      msg: null,
      products: [],
      sortType: null,
    };
  },
  beforeMount() {
    if (this.productData.length > 0) this.products = this.productData;
    this.sortType = this.sorting;
  },
  methods: {
    sortProducts(item) {
      if (item == this.sortType) this.sortType = null;
      else this.sortType = item;
      this.$emit("stepper", {
        sort: this.sortType,
      });
    },
    addToCart(productid) {
      if (!store.state.isLoggedIn) {
        this.$router.push("/Login");
      }
      var cart = {};
      cart["productid"] = productid;
      cart["quantity"] = 1;
      cart["update"] = true;
      axios({
        method: "POST",
        url: "/Cart/Addorupdate",
        data: cart,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = response.data.msg;
            store.commit("changeCart", response.data.count);
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
  },
};
</script>